import styled from "styled-components";

export const AppWrapper = styled.div`
  height: 100vh;
  background-color: ${(props) => props.theme.colors.NEUTRAL_PANEL};
  overflow: auto;
`;
